/**
 * @ngdoc service
 * @module portaro.components.global-search
 * @name globalSearchService
 *
 * @description
 * This service ensures global searching in cooperation with {@link component:kpGlobalSearch kpGlobalSearch component}
 */
export default class GlobalSearchService {
    static serviceName = 'globalSearchService';

    /** @type {GlobalSearchComponentController} */
    searchComponentController;

    /**
     * @ngdoc method
     * @name globalSearchService#setSearchComponentController
     *
     * @param {GlobalSearchComponentController} searchController Component controller for link with service
     *
     * @description
     * Internal method used for link component with service
     */
    setSearchComponentController(searchController) {
        this.searchComponentController = searchController;
    }

    /**
     * @ngdoc method
     * @name globalSearchService#search
     *
     * @param {string=} searchPhrase Search phrase
     *
     * @description
     * This method sets search phrase to form element and trigger submit.
     * If searchPhrase is empty, method triggers search with value from directive searchPhrase parameter.
     */
    search(searchPhrase) {
        if(searchPhrase) {
            this.searchComponentController.searchValue = searchPhrase;
        }
        this.searchComponentController.search();
    }
}